export const ROUTE_NAME = {
  C_OFFER: 'c-offer',
  C_OFFER_OVERVIEW: 'c-offer-overview',
  C_OFFER_SUCCESS: 'c-offer-success',
}

/**
 * Initial product decision made by Sanitas
 */
export const PRODUCT_DECISIONS = {
  ACCEPTED: 'ACCEPTED',
  DECLINED: 'DECLINED',
  DEFERRED: 'DEFERRED',
  IPZ: 'IPZ',
  DOCTOR_REPORT: 'DOCTOR_REPORT',
  IPZ_WITH_RESERVATIONS: 'IPZ_WITH_RESERVATIONS',
  NO_DECISION: 'NO_DECISION',
  SELECTION_IPZ_OR_RESERVATIONS: 'SELECTION_IPZ_OR_RESERVATIONS',
  SELECTION_IPZ_WITH_RESERVATIONS_OR_RESERVATIONS: 'SELECTION_IPZ_WITH_RESERVATIONS_OR_RESERVATIONS',
  WITH_RESERVATIONS: 'WITH_RESERVATIONS',
}

export const FAQ_TOPICS = {
  IPZ: 'IPZ',
  RESERVATIONS: 'RESERVATIONS',
  OPTIONS: 'OPTIONS',
  DECLINED: 'DECLINED',
  DEFERRED: 'DEFERRED',
  CANCELLATION: 'CANCELLATION',
}

export const FAQ_STATE = {
  IPS: 'ips',
  OPTION: 'option',
  REJECTED: 'rejected',
  RESTRICTION: 'restriction',
}

export const PRODUCT_PRICING_TAG = {
  CAVEAT: 'caveat',
  DISCOUNT: 'discount',
  IPZ: 'ipz',
  SURCHARGE: 'surcharge',
}

export const PERSON_ROLE = {
  CHILD: 'CHILD',
  HEAD: 'HEAD',
  PARTNER: 'PARTNER',
}

export const CONTACT_DATA = {
  EMAIL: 'application@sanitas.com',
  MOBILE: '0844 967 967',
}
